import {isForeignDocumentDetailsStepValid, ForeignDocumentDetailsStepValues} from './foreignDocument';
import {isInnDigitsValid} from './inn';
import {
	isPassportDetailsStepValid,
	PassportDetailsStepValues,
	requiresPassportDepartmentCode,
	requiresPassportIdentificationNumber,
	requiresPassportLatinNames,
	requiresPassportRegistrationAddress,
	usesBelarusPassportNumber,
} from './passport';
import {isPaymentSubStepValid, PaymentDetailsValues} from './paymentDetails';
import {PaymentSubStep} from './paymentFlow';
import {RegistrationPaymentMethod} from './paymentMethod';
import {InnStepValues, PersonalInfoStepValues, RegistrationWorkStatus} from './types';

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export const isPersonalInfoStepValid = (values: PersonalInfoStepValues): boolean => {
	return (
		Boolean(values.citizenshipOksmCode) &&
		Boolean(values.residenceOksmCode) &&
		Boolean(values.gender) &&
		values.secondName.trim().length > 0 &&
		values.firstName.trim().length > 0 &&
		EMAIL_PATTERN.test(values.email.trim())
	);
};

export const isDocumentDetailsStepValid = (options: {
	useForeignDocumentDetails: boolean;
	russianDetails: PassportDetailsStepValues;
	foreignDetails: ForeignDocumentDetailsStepValues;
	citizenshipOksmCode?: string | null;
	residenceOksmCode?: string | null;
}): boolean => {
	return options.useForeignDocumentDetails
		? isForeignDocumentDetailsStepValid(
				options.foreignDetails,
				options.citizenshipOksmCode,
				options.residenceOksmCode,
			)
		: isPassportDetailsStepValid(options.russianDetails, {
				requireRegistrationAddress: requiresPassportRegistrationAddress(
					options.residenceOksmCode,
					options.citizenshipOksmCode,
				),
				requireIdentificationNumber: requiresPassportIdentificationNumber(options.citizenshipOksmCode),
				requireLatinNames: requiresPassportLatinNames(options.citizenshipOksmCode),
				requireDepartmentCode: requiresPassportDepartmentCode(options.citizenshipOksmCode),
				belarusPassportNumber: usesBelarusPassportNumber(options.citizenshipOksmCode),
			});
};

/** ИНН на экране паспорта необязателен, но если начали вводить — нужен полный. */
export const isOptionalInnValid = (values: InnStepValues): boolean => {
	return values.inn.length === 0 || isInnDigitsValid(values.inn);
};

export const isWorkStatusStepValid = (workStatus: RegistrationWorkStatus | null): boolean => {
	return workStatus !== null;
};

export const isInnStepValid = (values: InnStepValues): boolean => {
	return isInnDigitsValid(values.inn);
};

export const isPaymentDetailsStepValid = (
	method: RegistrationPaymentMethod | null,
	subStep: PaymentSubStep,
	values: PaymentDetailsValues,
	workStatus?: RegistrationWorkStatus | null,
): boolean => {
	if (!method) {
		return false;
	}

	return isPaymentSubStepValid(method, subStep, values, {workStatus});
};
